export type RotationStrategyName =
    | 'DEFAULT_6_ROTATIONS'
    | 'DEFAULT_FLAT_ROTATIONS'
    | 'ADR_RESTRICTED'
    | 'NO_STACKING'
    | 'CUSTOM'

export interface RotationAxisFlags {
    allowRotationX: boolean
    allowRotationY: boolean
    allowRotationZ: boolean
}

/**
  Preset de stratégie de rotation qui définit les axes X, Y, Z.
  - DEFAULT_6_ROTATIONS: 6 rotations (tous les axes autorisés)
  - ADR_RESTRICTED: 2 rotations (Axe Z seul autorisé : base + pivotement à plat)
  - NO_STACKING: 1 orientation fixe (aucun axe autorisé)
  - CUSTOM: conservé tel quel sans modification automatique d'axes
 */
export function applyRotationPreset(strategy?: string): RotationAxisFlags {
    switch (strategy) {
        case 'DEFAULT_6_ROTATIONS':
            // Tous les axes autorisés => 6 permutations distinctes
            return { allowRotationX: true, allowRotationY: true, allowRotationZ: true }
        case 'DEFAULT_FLAT_ROTATIONS':
        case 'ADR_RESTRICTED':
            // Matières dangereuses : pivotement horizontal uniquement (ADR), pas de basculement
            // Z=vrai => échange L↔W (rester à plat)
            return { allowRotationX: false, allowRotationY: false, allowRotationZ: true }
        case 'NO_STACKING':
            // Pas de rotation : 1 seule orientation fixée
            return { allowRotationX: false, allowRotationY: false, allowRotationZ: false }
        default:
            return { allowRotationX: true, allowRotationY: true, allowRotationZ: true }
    }
}

/**
  Calcule la stratégie automatique selon les contraintes de l'item (fallback si pas de stratégie importée).
  Note: Le champ 'fragile' est ignoré selon les règles de gestion.
 */
export function resolveAutoStrategy(item: {
    is_hazardous?: boolean
    dangerous_goods?: boolean
    adr_class?: any
    stackable?: boolean
}): RotationStrategyName {
    const isAdr = !!(item.is_hazardous || item.dangerous_goods || item.adr_class)
    const isStackable = item.stackable !== false
    if (isAdr) return 'ADR_RESTRICTED'
    if (!isStackable) return 'NO_STACKING'
    return 'DEFAULT_6_ROTATIONS'
}
